window.addEventListener('resize', setEqualHeight);

// Call the function initially
setEqualHeight();

function setEqualHeight() {
	if(window.innerWidth < 768) {
		return;
	}

	// Get all the price and price text elements
	const priceElements = document.querySelectorAll('.pricing-table__item:not(.small) .pricing-table__item_price');
	const priceTextElements = document.querySelectorAll('.pricing-table__item:not(.small) .pricing-table__item_price-text');
	const priceElementsSmall = document.querySelectorAll('.small .pricing-table__item_price');
	const priceTextElementsSmall = document.querySelectorAll('.small .pricing-table__item_price-text');

	priceElements.forEach(el => {
		el.style.height = 'auto';
	});

	priceTextElements.forEach(el => {
		el.style.height = 'auto';
	});

	priceElementsSmall.forEach(el => {
		el.style.height = 'auto';
	});

	priceTextElementsSmall.forEach(el => {
		el.style.height = 'auto';
	});

	// Find the maximum height among all price elements
	const maxHeightPrice = Math.max(...Array.from(priceElements, el => el.offsetHeight));
	const maxHeightPriceText = Math.max(...Array.from(priceTextElements, el => el.offsetHeight));
	const maxHeightPriceSmall = Math.max(...Array.from(priceElementsSmall, el => el.offsetHeight));
	const maxHeightPriceTextSmall = Math.max(...Array.from(priceTextElementsSmall, el => el.offsetHeight));

	// Set the height for all price and price text elements to the maximum height
	priceElements.forEach(el => {
		el.style.height = maxHeightPrice + 'px';
	});

	priceTextElements.forEach(el => {
		el.style.height = maxHeightPriceText + 'px';
	});

	priceElementsSmall.forEach(el => {
		el.style.height = maxHeightPriceSmall + 'px';
	});

	priceTextElementsSmall.forEach(el => {
		el.style.height = maxHeightPriceTextSmall + 'px';
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/pricing-table-adaptive.js